import { IonButton, IonImg, IonItem, IonLabel, IonList, IonThumbnail } from '@ionic/react'
import './Autocomplete.css'
import { _dict } from './constants'
import { useGlobalStore } from './stateManagement/globalZustand'
import { useTreeStore } from './stateManagement/treeZustand'
import { label2LabelToShow } from '../foo/cards'

interface AutocompleteProps {
  topSentencesStringArrayOnly: any,
  handleAutocomplete:any,
  handleReset:any,
  lang:string
}

const Autocomplete: React.FC<AutocompleteProps> = ({ topSentencesStringArrayOnly,  handleAutocomplete, handleReset, lang }) => {
  const { isParentMode } = useGlobalStore();
  const { getImage } = useTreeStore();
  return (
    <IonList lines="full">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          { isParentMode ?
          <IonButton onClick={handleReset} color="danger">
            {_dict.resetTopSentences[lang]}
          </IonButton> : null }
        </div>
        {topSentencesStringArrayOnly.map((words: string[], index: number) => (
        <IonItem className="item-spacing" onClick={() => handleAutocomplete(words)} key={index}>
        {words.map((word, widx) => (
        <div key={widx} className="word-spacing">
            <div className="thumbnail-container">
                <IonThumbnail className="rounded-thumbnail">{getImage(word) ? <IonImg src={getImage(word)} /> : null}</IonThumbnail>
            </div>
            <div className="thumbnail-container">
                <IonLabel>{label2LabelToShow(word, lang)}</IonLabel>
            </div>
            
        </div>
        ))}
        </IonItem > 
        ))}
    </IonList> 
  )
}

export default Autocomplete